// extracted by mini-css-extract-plugin
export default {"main":"MainPage_main__32sN+","inputs_and_btn":"MainPage_inputs_and_btn__0EC36","btn":"MainPage_btn__4y5B0","tasks":"MainPage_tasks__Q0Ss8"};